import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { PublicLayout } from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderResultPage from "@/pages/OrderResultPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AccountPage from "@/pages/AccountPage";
import AdminLayout from "@/pages/admin/AdminLayout";

function App() {
    return (
        <AuthProvider>
            <CartProvider>
                <BrowserRouter>
                    <Toaster richColors position="top-right" />
                    <Routes>
                        <Route path="/admin/*" element={<AdminLayout />} />
                        <Route path="*" element={
                            <PublicLayout>
                                <Routes>
                                    <Route path="/" element={<HomePage />} />
                                    <Route path="/tienda" element={<ShopPage />} />
                                    <Route path="/producto/:id" element={<ProductPage />} />
                                    <Route path="/carrito" element={<CartPage />} />
                                    <Route path="/checkout" element={<CheckoutPage />} />
                                    <Route path="/pedido/:id" element={<OrderResultPage />} />
                                    <Route path="/login" element={<LoginPage />} />
                                    <Route path="/registro" element={<RegisterPage />} />
                                    <Route path="/cuenta" element={<AccountPage />} />
                                </Routes>
                            </PublicLayout>
                        } />
                    </Routes>
                </BrowserRouter>
            </CartProvider>
        </AuthProvider>
    );
}

export default App;
